var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-page_profile t-work-area"},[_c('h1',[_vm._v(_vm._s(_vm.pageText.title))]),_vm._v(" "),_c('div',[_c('div',{staticClass:"t-work-area__cell"},[_c('cmp-balance',{attrs:{"small":false}})],1),_vm._v(" "),_c('div',{staticClass:"t-work-area__cell"},[_c('cmp-transactions',{attrs:{"small":false}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-243815c4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue_pages/Profile/Finance.vue
// module id = 288
// module chunks = 0